import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDowninline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.702 4.8l1.426 1.401-5.415 5.514a1 1 0 0 1-1.426 0L1.872 6.2l1.426-1.4L8 9.587 12.702 4.8z",
		fill: "currentColor"
	})
});
export default SvgChevronDowninline;
